import { InjectionToken } from '@angular/core';
import { MojoExternalCandidateContactInfoService } from 'mojo-external-candidate-contact-info';

export const EXTERNAL_CANDIDATE_CONTACT_INFO_POOLS_SERVICE =
  new InjectionToken<MojoExternalCandidateContactInfoService>(
    'MojoExternalCandidateContactInfoService',
  );
